import { Typography } from "@suraasa/placebo-ui"

const getSupportEmailURI = () => {
  const subject = encodeURIComponent("Issue with Assessment")
  const body = encodeURIComponent(`
  Hello Suraasa Team,
  I need help with my CPAT assessment regarding:
  `)
  return `mailto:care@suraasa.com?body=${body}&subject=${subject}`
}

export const NeedHelp = () => {
  return (
    <div className="mt-4 border-t pt-4 md:mt-8 md:pt-8">
      <div className="flex items-center gap-3">
        <div className="hidden size-6 items-center justify-center rounded-full bg-surface-200 text-black-600 lg:flex">
          <div className="size-3 rounded-full bg-current" />
        </div>
        <Typography variant="title3" className="text-onSurface-900">
          Need Help?
        </Typography>
      </div>
      <Typography variant="smallBody" className="mt-2 text-onSurface-700">
        If you experience technical issues, contact support at{" "}
        <a
          href={getSupportEmailURI()}
          className="text-interactive-500 underline hover:text-interactive-600"
        >
          care@suraasa.com
        </a>
        .
      </Typography>
    </div>
  )
}
